import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const authAPI = {
  demoLogin: async (userType) => {
    const response = await apiClient.post('/auth/demo-login', {
      user_type: userType
    });
    return response.data;
  }
};

// Requests API
export const requestsAPI = {
  create: async (requestData, submittedBy) => {
    const response = await apiClient.post(`/requests/create?submitted_by=${submittedBy}`, requestData);
    return response.data;
  },
  
  getUserRequests: async (userId) => {
    const response = await apiClient.get(`/requests/user/${userId}`);
    return response.data;
  },
  
  getPendingApprovals: async (approverId) => {
    const response = await apiClient.get(`/requests/pending/${approverId}`);
    return response.data;
  },
  
  getRequest: async (requestId) => {
    const response = await apiClient.get(`/requests/${requestId}`);
    return response.data;
  },
  
  approveRequest: async (requestId, action, approverId) => {
    const response = await apiClient.post(
      `/requests/${requestId}/approve?approver_id=${approverId}`,
      action
    );
    return response.data;
  }
};

// General API
export const generalAPI = {
  healthCheck: async () => {
    const response = await apiClient.get('/');
    return response.data;
  }
};

export default apiClient;